<div class="wrapper wrapper-content animated fadeInRight">
  <div class="row">
    <div class="col-lg-12">
      <div class="ibox">
        <div class="ibox-title">
          <h5>Close Tournament</h5>
        </div>
        <div class="ibox-content">
          @if (selectedTournament()) {
            <div class="tournament-close-container">
              <h3>{{ selectedTournament()!.name }}</h3>
              <p class="text-muted">{{ selectedTournament()!.year }} - {{ selectedTournament()!.city }}</p>

              <div class="tournament-details">
                <div class="detail-row">
                  <span class="label-text">Status:</span>
                  <span [class]="selectedTournament()!.official ? 'badge badge-primary' : 'badge badge-info'">
                    {{ selectedTournament()!.official ? 'Official' : 'Active' }}
                  </span>
                </div>

                <div class="detail-row">
                  <span class="label-text">Purse:</span>
                  <span>{{ selectedTournament()!.purse | currency }}</span>
                </div>
              </div>

              <div class="rounds-section mt-4">
                <h4>Rounds Status</h4>
                @if (isLoading()) {
                  <div class="text-center">
                    <i class="fa fa-spinner fa-spin fa-2x"></i>
                    <p>Loading rounds...</p>
                  </div>
                } @else {
                  <div class="table-responsive">
                    <table class="table table-striped">
                      <thead>
                        <tr>
                          <th>Round</th>
                          <th>Start Date</th>
                          <th>End Date</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        @for (round of rounds(); track round.roundId) {
                          <tr>
                            <td>Round {{ round.number }}</td>
                            <td>{{ round.startDate | date:'short' }}</td>
                            <td>{{ round.endDate | date:'short' }}</td>
                            <td>
                              <span [class]="getRoundStatusClass(round)">
                                {{ getRoundStatusText(round) }}
                              </span>
                            </td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  </div>
                }
              </div>

              <div class="form-group mt-4">
                <button 
                  type="button" 
                  class="btn btn-primary btn-lg"
                  [disabled]="!canClose() || isClosing()"
                  (click)="confirmCloseTournament()">
                  @if (isClosing()) {
                    <i class="fa fa-spinner fa-spin"></i> Closing Tournament...
                  } @else {
                    <i class="fa fa-lock"></i> Close Tournament
                  }
                </button>
              </div>

              @if (!canClose() && !isLoading()) {
                <div class="alert alert-warning mt-3">
                  <i class="fa fa-warning"></i>
                  @if (selectedTournament()!.official) {
                    This tournament is already official and cannot be closed again.
                  } @else if (!allRoundsOfficial()) {
                    All rounds must be official before the tournament can be closed.
                  }
                </div>
              }
            </div>
          } @else {
            <div class="alert alert-warning">
              <i class="fa fa-warning"></i> No tournament selected. Please select a tournament from the main navigation.
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>
